var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isContentReady
    ? _c(
        "div",
        { staticClass: "row row--grid" },
        [
          _vm._l(_vm.selection, function(item) {
            return [
              _c("v-deal", { attrs: { item: item, lexicon: _vm.lexicon } })
            ]
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }